/**
 * The zone lab, as the menu sees it.
 *
 * A development tool with a card: fly through a generated zone and build it again from another
 * recipe without leaving. Registered only in development, and its code sits behind the same
 * `import.meta.env.DEV` gate the dev hosts use, so a build carries no chunk for it.
 */

import { ZONE_ARCHETYPE_ORDER } from '@/sim/worldgen/zoneArchetypeRegistry';
import {
  ZONE_LAB_FACT_BUILD,
  ZONE_LAB_FACT_BUILD_VALUE,
  ZONE_LAB_FACT_PLACES,
} from '@/modes/zoneLab/text/zoneLabCardText';
import type { GameMode, ModeCode } from '@/modes/modeContract';

export const ZONE_LAB: GameMode = {
  id: 'zoneLab',
  title: 'Zone lab',
  tagline: 'Fly through a generated zone and roll it again',
  facts: [
    { label: ZONE_LAB_FACT_PLACES, value: String(ZONE_ARCHETYPE_ORDER.length) },
    { label: ZONE_LAB_FACT_BUILD, value: ZONE_LAB_FACT_BUILD_VALUE },
  ],
  controls: ['pointerLock'],
  party: 'solo',
  hasBackdrop: false,
  async load(): Promise<ModeCode> {
    // The gate at the call site, so the chunk is never emitted in a build: an unguarded import()
    // is reachable code whether or not anything calls it.
    if (!import.meta.env.DEV) throw new Error('the zone lab is not in a build');
    const app = await import('@/modes/zoneLab/zoneLabApp');
    return { launch: app.startZoneLab, createBackdrop: null };
  },
};
